import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1012"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M11.296 8.089a3.074 3.074 0 0 0 1.436-.404c.11.052.742.336 1.422.05.691-.291 1.073-1.022 1.039-1.686-.045-.872-.807-1.648-1.822-1.737a2.638 2.638 0 0 0-1.573-1.017c-.16-1.419-1.305-2.466-2.57-2.486-1.01-.015-1.97.627-2.422 1.624a2.595 2.595 0 0 0-2.014 1.473c-1.047-.14-1.789.409-2.115 1.063a1.527 1.527 0 0 0-1.084.117c-.44.233-.784.711-.785 1.273-.001.638.441 1.16.97 1.359.656.247 1.238-.081 1.32-.129.152.129.712.574 1.543.575.502.001.895-.161 1.137-.292v2.656c0 1.608-1.31 2.662-2.912 2.547-.573-.041-.98.367-.98.746s.408.736.98.695c2.393-.172 4.351-1.585 4.351-3.987V8.101c.223.019.462.021.721-.012.342-.044.636-.136.881-.238v2.676c0 2.402 1.808 3.862 4.351 3.987.573.028 1.012-.341 1.012-.72 0-.379-.439-.761-1.012-.72-1.602.115-2.912-.939-2.912-2.547V7.924c.293.098.635.176 1.038.165z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }